import React from "react";
import qs from "qs";
import withTranslations from "../../../../../hocs/withTranslations";
import { Redirect } from "react-router";

const LocalizedRouteRedirect = ({ locale, location }) => {
  const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  if (searchParams.authRedirect) {
    return null;
  }

  return (
    <Redirect
      to={{
        pathname: `/${locale}${location.pathname}`,
        search: location.search,
        hash: location.hash
      }}
    />
  );
};

LocalizedRouteRedirect.propTypes = {};

export default withTranslations(LocalizedRouteRedirect);
